var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.07,17.67a1.37,1.37,0,0,1,0-.85,1.35,1.35,0,0,1,.51-.69L20.2,9.26a1.36,1.36,0,0,1,1.6,0l9.63,6.87a1.39,1.39,0,0,1,.22,2,1.41,1.41,0,0,1-1,.46H11.37a1.41,1.41,0,0,1-.81-.27,1.38,1.38,0,0,1-.49-.69Zm9.21-3.17a1.72,1.72,0,1,0,.5-1.21A1.72,1.72,0,0,0,19.28,14.5Z",
    fill: "#624de3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,29.62a1.34,1.34,0,0,1-.4,1,1.38,1.38,0,0,1-1,.41H11.37a1.37,1.37,0,0,1-1.19-.69,1.39,1.39,0,0,1,0-1.37,1.37,1.37,0,0,1,1.19-.69h2.75V22.06a1.39,1.39,0,0,1,.69-1.19,1.41,1.41,0,0,1,1.38,0,1.39,1.39,0,0,1,.68,1.19v6.19h2.75V22.06a1.37,1.37,0,0,1,.69-1.19,1.39,1.39,0,0,1,1.37,0,1.37,1.37,0,0,1,.69,1.19v6.19h2.75V22.06a1.37,1.37,0,0,1,.69-1.19,1.39,1.39,0,0,1,1.37,0,1.37,1.37,0,0,1,.69,1.19v6.19h2.75A1.37,1.37,0,0,1,32,29.62Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntity);
export default __webpack_public_path__ + "static/media/entity.41dc95b3449530ca1f0638261b90c628.svg";
export { ForwardRef as ReactComponent };